import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes, SubmissionError } from 'redux-form';
import { required } from '../../ReduxForm/validation';
import { ReduxFormField } from '../../ReduxForm/ReduxFormField';
import { ReduxFormSubmitButton } from '../../ReduxForm/ReduxFormSubmitButton';
import { noop } from '../../../utilities/functions';

import './styles.scss';

class _LoginForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    onForgotPassword: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
  };

  onSubmit = ({ email, password }) => {
    const { onLogin } = this.props;
    return new Promise((resolve, reject) => {
      onLogin(email, password, resolve, reject);
    }).then(noop, (errors) => {
      throw new SubmissionError(errors);
    });
  };

  render() {
    const { handleSubmit, error, onForgotPassword, submitting } = this.props;

    return (
      <div className="login-form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            name="email"
            type="text"
            label="Email or profile name"
            component={ReduxFormField}
            validate={required}
          />
          <Field
            name="password"
            type="password"
            label="Password"
            component={ReduxFormField}
            validate={required}
          />
          <div className="forgot-password">
            <button
              type="button"
              className="link_forgot"
              onClick={onForgotPassword}
            >
              Forgot password
            </button>
          </div>
          {error && <div className="form-error">{error}</div>}
          <ReduxFormSubmitButton label="Start learning" {...{ submitting }} />
        </form>
      </div>
    );
  }
}

export const LoginForm = reduxForm({
  form: 'login',
})(_LoginForm);

export const ModalLoginForm = reduxForm({
  form: 'modalLogin',
})(_LoginForm);
